import {RestService} from "@/services/rest/RestService";
import {DeliveryPickupLocationAPIApi} from "@/api/pharma-order-settings";
import {DeliveryPickupLocationOverviewRestDto, DeliveryPickupLocationRestDto} from "@/api/pharma-order-settings/models";
import {ValueEnum} from "@/api/enums/value-enum";
import {isEmptyString} from "@/helpers/functions/string";

export class DeliveryPickupLocationRestService extends RestService {

    private apiService: DeliveryPickupLocationAPIApi;

    protected constructor() {
        super();

        this.apiService = new DeliveryPickupLocationAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().orderUrl);
    }


    public async findDeliveryPickupLocations(): Promise<DeliveryPickupLocationOverviewRestDto[]> {
        const response = await this.apiService.findDeliveryPickupLocations();

        return response.data.results;
    }

    public async updateDeliveryPickupLocationStatus(status: ValueEnum, id: string): Promise<void> {
        await this.apiService.updateDeliveryPickupLocationStatus({value: status}, id);
    }

    public async addDeliveryPickupLocation(body: DeliveryPickupLocationRestDto): Promise<void> {
        this.beforeSave(body);
        await this.apiService.createDeliveryPickupLocation(body);
    }

    public async getDeliveryPickupLocation(id: string): Promise<DeliveryPickupLocationRestDto> {
        const response = await this.apiService.getDeliveryPickupLocation(id);
        return response.data;
    }

    public async updateDeliveryPickupLocation(body: DeliveryPickupLocationRestDto, id: string): Promise<void> {
        this.beforeSave(body);
        await this.apiService.updateDeliveryPickupLocation(body, id);
    }

    public async deleteDeliveryPickupLocation(id: string): Promise<void> {
        await this.apiService.deleteDeliveryPickupLocation(id);
    }

    private beforeSave(body: DeliveryPickupLocationRestDto): void {
        if (body.address === null) {
            return;
        }

        if (isEmptyString(body.address!.street)
            && isEmptyString(body.address!.extra_address_line)
            && isEmptyString(body.address!.house_number)
            && isEmptyString(body.address!.box)
            && isEmptyString(body.address!.postal_code)
            && isEmptyString(body.address!.postal_code_addition)
            && isEmptyString(body.address!.city_name)
            && isEmptyString(body.address!.country_name)
        ) {
            body.address = null;
        }
    }
}
